import React, { Component } from "react";
import axios from "axios";
import $ from "jquery";
import Headers from "../Layouts/Headers";
import { config } from "../_helpers/global";
import { TriageSidebar } from "../Layouts/TriageSidebar";

export class SexualHistory extends Component {
  constructor(props) {
    super(props);

   

    const url = "";

    this.state = {
      FirstActivityAge: "",
      NumberOfPartners: "",
      AssaultOrAbuseHistory: "",
      loading: false
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.PrintWindow = this.PrintWindow.bind(this);
  }

  componentDidMount() {}

  handleChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  PrintWindow(event) {
    document.title =
      localStorage.getItem("currentVisitName") + "`s " + this.constructor.name;
    $(".modal").hide();
    window.print();
  }

  handleSubmit = (event) => {
    const headers = {
      "Content-Type": "application/json",
      token: localStorage.getItem("accessToken"),
      visitid: localStorage.getItem("currentVisitId"),
    };
    event.preventDefault();
    this.setState({
      loading: true
    })
    axios
      .post(
        this.api_url+""+localStorage.getItem('currentModule')+"/sexualhistory/main",
        this.state,
        {
          headers: headers,
        }
      )
      .then((response) => {
        this.setState({
          loading: false
        })

        if (response.data["status"]) {
          $(".alert-success").show();
          setTimeout(function () {
            window.location.href = "/prior/ob/or/gyn/infections";
          }, 500);
        }
      })
      .catch((error) => {
        console.log(error);
        $('#SubmitError').show();
        $(".alert-success").hide();
      });
  };

  render() {
    const font16 = { fontSize: "18px" };
    const fontFamilyNunito = { fontFamily: "Nunito, sans-serif" };
    const floatRight = { float: "right;" };
    const floatLeft = { float: "left;" };
    const displayHidden = { display: "none" };

    const { FirstActivityAge, NumberOfPartners, AssaultOrAbuseHistory ,loading } =
      this.state;
    return (
      <div>
        <Headers />
        <TriageSidebar></TriageSidebar>

        <main className="content-container ">
          <div className="container p-2">
            <form onSubmit={this.handleSubmit}>
              <div className="form-row pt-4">
                <div className="col-md-12 font-weight-bold p-1">
                  <p className="text-capitalize" style={font16}>
                    Sexual History
                  </p>
                </div>
                <div className="col-md-6 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Age of first sexual activity
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={FirstActivityAge}
                      name="FirstActivityAge"
                      type="number"
                      required
                    />
                  </div>
                </div>
                <div className="col-md-6 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Number of partners
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={NumberOfPartners}
                      name="NumberOfPartners"
                      type="number"
                      required
                    />
                  </div>
                </div>
                <div className="col-md-6 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      History of sexual assault or abuse
                    </h6>
                    <textarea
                      className="form-control"
                      onChange={this.handleChange}
                      value={AssaultOrAbuseHistory}
                      name="AssaultOrAbuseHistory"
                      required
                    ></textarea>
                  </div>
                </div>
              </div>
              <div
                className="alert alert-danger"
                id="SubmitError"
                style={displayHidden}
                role="alert"
              >
                <strong> </strong>Something went wrong. Please try again
              </div>
              <div
                id="loginSuccess"
                className="alert alert-success"
                style={displayHidden}
                role="alert"
              >
                <strong>Success! </strong>Sexual History Saved Successfully.
              </div>

              <div className="row">
                <br />
                {/* <div style={displayHidden} className="col col-6"><button className="btn btn-primary btn-warning rounded-pill px-4 font-weight-bold" type="button" style={floatRight}>Send To Triage</button></div> */}
                <div className="col col-6">
                  <button
                    className="btn btn-primary btn-warning rounded-pill px-5 font-weight-bold"
                    type="submit"
                    style={floatLeft}
                  >
                  {loading ? 'Loading' : 'Submit'}  
                  </button>
                </div>
              </div>
            </form>
          </div>
        </main>
      </div>
    );
  }
}

export default SexualHistory;
